import { useEffect, useState } from "react";

// Counts down to the next 18:00 local time. Resets after 18h to next day.
const computeTimeLeft = () => {
  const now = new Date();
  const target = new Date(now);
  target.setHours(18, 0, 0, 0);
  if (now >= target) target.setDate(target.getDate() + 1);
  const diff = Math.max(0, target.getTime() - now.getTime());
  const h = Math.floor(diff / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1000);
  return { h, m, s };
};

const pad = (n) => String(n).padStart(2, "0");

const ShipTodayCountdown = ({ lang = "fr" }) => {
  const [t, setT] = useState(computeTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setT(computeTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  const isFr = lang === "fr";
  return (
    <div
      data-testid="ship-today-countdown"
      className="mt-4 bg-[#D4C4B0] border border-[#C0AE94] text-[#3D2B1F] px-5 py-3 rounded-sm flex items-center justify-between gap-4"
    >
      <div className="text-[13px] md:text-sm leading-snug">
        <span className="mr-1.5">⚡</span>
        {isFr ? (
          <>Commandez avant 18h — <strong className="font-medium">Expédié aujourd'hui</strong></>
        ) : (
          <>Order before 6pm — <strong className="font-medium">ships today</strong></>
        )}
      </div>
      <div
        className="font-serif-display text-xl md:text-2xl tracking-wider tabular-nums whitespace-nowrap"
        aria-live="polite"
      >
        {pad(t.h)}:{pad(t.m)}:{pad(t.s)}
      </div>
    </div>
  );
};

export default ShipTodayCountdown;
